import React from 'react';
import { NavigationItem } from 'ui-toolkit';
import { clientUrls } from '../../../ui-toolkit/rest/ClientUrlFactory';
import { addressDataToString } from '../../../ui-toolkit/orders/interfaces/IAddressResponse';
import { ISearchOrderData } from '../../../ui-toolkit/orders/searchOrder/types/ISearchOrder';

export const OrderBorrowerCell: React.FC<{
  data?: string;
  id: string;
}> = ({ data, id }) => (
  <>{data && <NavigationItem to={clientUrls.urlFor.clientOrderOverview(id)} text={data} isInline />}</>
);

export const OrderAddressCell = ({ data }: { data: ISearchOrderData }) => (
  <span>{addressDataToString(data.propertyAddress)}</span>
);
